module.exports = __webpack_public_path__ + "static/media/home2189.44b8c3cd.png";